/**
 * Alice chat client — talks to the Cascade Worker's scoped assistant.
 */

import { request } from './api';

export interface AliceMessage {
  role: 'user' | 'assistant';
  content: string;
}

/**
 * What the user is looking at.
 *
 * `lead`, `contact`, and `organization` are hydrated server-side into the system
 * prompt. `call` and `form_entry` are passed as a pointer only — Alice has tools
 * that read those in full, so naming the record is enough and avoids paying for
 * a transcript on every turn whether or not the question is about it.
 */
export interface AliceContext {
  kind: 'lead' | 'contact' | 'organization' | 'call' | 'form_entry';
  id: string;
}

/** A UI launch can pin Alice to a record even when it starts from a feed card. */
export interface AliceLaunch {
  prompt: string;
  nonce: number;
  context?: AliceContext;
  contextLabel?: string;
}

export function askAlice(messages: AliceMessage[], context?: AliceContext) {
  return request<{ message: AliceMessage }>('/api/copilot/chat', {
    method: 'POST',
    body: JSON.stringify({ messages, context }),
  });
}
